module.exports = __webpack_public_path__ + "img/shield.2b773dbe.png";